module.exports = __webpack_public_path__ + "static/media/privacy-full.6b3e3dc8.css";


//////////////////
// WEBPACK FOOTER
// ./public/assets/css/privacy-full.css
// module id = 45
// module chunks = 0